import { createStore } from "../../../utils/states";
import { CalendarDateSelectorState } from "../types";

const initialState: CalendarDateSelectorState = {
  viewDate: new Date(),
  range: { start: null, end: null },
  mainMode: "day",
  isRangePicker: false,
  showCard: false,
};

const { useState: useCalendarDateSelectorState, useActions: useSetCalendarDateSelector } = createStore<CalendarDateSelectorState>(initialState);

export { useCalendarDateSelectorState, useSetCalendarDateSelector };
